import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Category10 from "../../components/category/Category10";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumbblog from "../../components/breadcrumbblog";
import { useParams } from "react-router-dom";

BlogDetails.propTypes = {};

function BlogDetails(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
const [language, setLanguage] = useState("en");

  const { clientId } = useParams();
  const [category, setCategory] = useState({
  Title: "",
  Title2: "",
  Path1: "",
  Descriptions: "",
  Descriptions2: "",
  Bid: "",
  Sdesc: "",
  Sdesc2: "",
  Aid: "",
  Expertstatus: ""
});

  useEffect(() => {
    const fetchCategoryDetails = async () => {
      try {
        const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/get-blog-article-details/${clientId}`);
        setCategory(response.data);
      } catch (error) {
        console.error("Error fetching category details:", error);
      }
    };

    fetchCategoryDetails();
  }, [clientId]);

const hasHindi = Boolean(
  category.Descriptions2
    ?.replace(/<[^>]*>/g, "") // Remove HTML tags
    .replace(/&nbsp;/g, "")   // Remove non-breaking spaces
    .trim()
);

const hasHindiTitle = Boolean(
  category.Title2?.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, "").trim()
);

const hasHindiSdesc = Boolean(
  category.Sdesc2?.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, "").trim()
);

  const [author, setAuthor] = useState({ Aname: "", Atitle: "", Adesc: "", Path1: "" }); // adjust based on your Bauthors table
  // Second API call - fetch author once Aid is available
  useEffect(() => {
    const fetchAuthorDetails = async () => {
      if (category.Aid) {
        try {
          const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/get-author-details/${category.Aid}`);
          setAuthor(response.data);
        } catch (error) {
          console.error("Error fetching author details:", error);
        }
      }
    };

    fetchAuthorDetails();
  }, [category.Aid]);

  const [blogs, setBlogs] = useState([]);

  // Fetch data from MySQL
   useEffect(() => {
    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogssortinside`, {
        params: { excludeClientId: clientId }
      })
      .then((response) => {
        setBlogs(response.data);
      })
      .catch((error) => {
        console.error("Error fetching blog data:", error);
      });
  }, [clientId]);
  return (
    <>
   <Helmet>
     <title>{category?.Title ? `${category.Title} - Adhigyanam | Sauntesthyam LLP` : 'Loading... | Adhigyanam'}</title>
   </Helmet>
      <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

         <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
          <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "white",
    borderColor: "transparent",
    textTransform: "capitalize"}}>
            <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
          </div>
          <div className="header-customize-item button">
            <Link to="/login">My Account</Link>
          </div>

          <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                </h6>
              </div>
            </div>
            <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
            <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
            <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
      <ul className="list-social d-flex aln-center">
                                     <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                     <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                     <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                 </ul>
    </div>
          </div>
        </div>
      </div>
      
      <Header2 clname="act1" handleMobile={handleMobile} />
        <Breadcrumbblog title="Read Article" />
     
        <section className="testimonials-category-section" style={{ paddingTop: "20px", paddingBottom:"20px" }}>
          <div className="tf-container">
                <div className="row" style={{textAlign:"center", maxWidth:"1200px", margin:"auto"}}>
                    <div className="col-lg-8 col-12">
                     <>
  <style>{`
    .rich-content img {
      display: block;
      margin: 10px auto;
      max-width: 100%;
      height: auto;
      float: none !important;
      width: 100% !important;
    }

    .switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #ccc;
  transition: 0.3s;
  border-radius: 34px;
}

.slider:before {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  left: 3px;
  bottom: 3px;
  background: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background: #0d6efd;
}

input:checked + .slider:before {
  transform: translateX(24px);
}
  `}</style>

 {(hasHindi || hasHindiTitle || hasHindiSdesc) && (
  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "10px",
      marginBottom: "15px",
      marginTop: "10px",
      fontWeight: "bold",
      fontSize: "15px",
    }}
  >
    <span>English</span>

    <label className="switch">
      <input
        type="checkbox"
        checked={language === "hi"}
        onChange={(e) =>
          setLanguage(e.target.checked ? "hi" : "en")
        }
      />
      <span className="slider"></span>
    </label>

    <span>हिन्दी</span>
  </div>
)}
            <h6 style={{

    marginTop: "20px",

    marginBottom: "5px",

    textAlign: "left"

  }}>

    {language === "hi" && hasHindiTitle

      ? category.Title2

      : category.Title}

  </h6>

  <p style={{

    marginBottom: "10px",

    textAlign: "left"

  }}>

    {language === "hi" && hasHindiSdesc

      ? category.Sdesc2

      : category.Sdesc}

  </p>

  <img

    src={category.Path1}

    alt={

      language === "hi" && hasHindiTitle

        ? category.Title2

        : category.Title

    }

    style={{

      width: "80%",

      height: "auto",

      borderRadius: "10px",

      border: "solid #f2f2f2 3px",

      margin: "auto"

    }}

  />
     
     {String(category.Expertstatus).trim() === "1" && (
  <div style={{ border: "solid #CEF6CE 2px", borderRadius: "5px", marginTop: "20px", backgroundColor: "#CEF6CE" }}>
    <p style={{ verticalAlign: "unset", padding: "15px", textAlign: "left" }}>
      <b>Expert Reviewed Content</b><br />
      Explore articles authored and reviewed by industry experts. Each piece is carefully vetted to ensure accuracy, relevance, and depth—providing you with credible guidance you can trust.
    </p>
  </div>
)}
    
    

 <div
  className="rich-content"
  style={{
    marginBottom: "5px",
    marginTop: "10px",
    textAlign: "left",
  }}
  dangerouslySetInnerHTML={{
    __html:
      language === "hi" && hasHindi
        ? category.Descriptions2
        : category.Descriptions,
  }}
></div>
</>

<div className="row" style={{textAlign:"center", border:"solid #f2f2f2 2px", borderRadius:"5px", marginTop:"15px", paddingTop:"10px", paddingBottom:"10px", backgroundColor:"#fafafa", margin:"0px"}}>
<div className="col-lg-2 col-12">
<img
          src={author.Path1} // Display image from Path1
          alt={author.Aname}
          style={{ width: "auto", height: "auto", borderRadius: "10px", maxWidth:"110px", textAlign:"left", float:"left" }}
        />
</div>
<div className="col-lg-10 col-12">
<h6 style={{marginTop:"10px", marginBottom:"0px", textAlign:"left", fontSize:"17px", color:"#14a077"}}>{author.Aname}</h6>
<p style={{marginBottom:"10px", textAlign:"left", fontWeight:"bold", fontSize:"14px"}}>{author.Atitle}</p>
<p style={{marginBottom:"10px", textAlign:"left"}}>{author.Adesc}</p>
</div>
</div>

<div style={{border:"solid #f2f2f2 2px", borderRadius:"5px", marginTop:"20px", textAlign:"left", backgroundColor:"#fafafa"}}>
     <p style={{verticalAlign:"unset", padding:"15px"}}><b>Knowledge Based Article</b><br/><i>This is a knowledge-based article intended solely for informational purposes. To maintain the integrity and focus of the content, commenting has been disabled.</i></p>
     </div>
                   
                    </div>
                    <div className="col-lg-4 col-12">
                    <div className="box-content"  style={{textAlign:"left", marginTop:"25px"}}>
                  <h3 style={{ marginBottom: "15px", fontSize: "16px", display: 'flex', textTransform:"uppercase", 
    justifyContent: 'space-between' }}>
  <b>Explore By Blog Categories</b>
</h3>
<hr/>
<ul style={{paddingLeft:"20px"}}>
       {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}  style={{color:"#14a077", fontSize:"15px", lineHeight:"16px", fontWeight:"bold"}}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}          
</ul>
      <h3 style={{ marginTop:"30px", marginBottom: "15px", fontSize: "16px", display: 'flex', textTransform:"uppercase", 
    justifyContent: 'space-between' }}>
  <b>Recently published Articles</b>
</h3>
<hr/>
{blogs.map((blog, index) => (
            <div key={index}>
              <div className="box-latest" style={{padding:"20px", backgroundColor:"whitesmoke", marginBottom:"15px", borderRadius:"5px"}}>
              <Link to={`/blog-details/${blog.Id}`}>
                  <img
                    src={blog.Path1 || "default-image.jpg"} // Replace with an actual default image
                    alt={blog.Title}
                  />
                  </Link>
                    <h6>
                      <Link to={`/blog-details/${blog.Id}`} style={{fontSize:"15px", lineHeight:"17px"}}>{blog.Title}</Link>
                    </h6>
                
              </div>
            </div>
          ))} 

                   
                  </div>

</div>
                    </div>
                   
          </div>
        </section>
      
      <div
                className="floating-buttons"
                style={{
                  position: "fixed",
                  bottom: "20px",
                  left: "20px",
                  zIndex: "1000",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {/* Call Button */}
                <a
                  href={`tel:+918960708425`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#007BFF",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaPhoneAlt />
                </a>
              
                {/* WhatsApp Button */}
                <a
                  href={`https://wa.me/918960708425`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#25D366",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaWhatsapp />
                </a>
              </div>
      <Footer />
      <Gotop />
    </>
  );
}

export default BlogDetails;
